import React from 'react';

const IconCalendly = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-calendar"
  >
    <title>Calendly</title>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M8 3v4" />
    <path d="M16 3v4" />
    <path d="M3 10h18" />
    <path d="M8 14h3" />
    <path d="M8 18h3" />
    <path d="M14 14h2" />
  </svg>
);

export default IconCalendly;